(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tls-fan-variant-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tls-fan-variant-panel')) {
    customElements.define('tls-fan-variant-panel', class extends HTMLElement {
      connectedCallback() {
        this.baseUrl = new URL(location.href);
        this.sequence = 0;
        this.contentNode = this.querySelector('[data-panel-content]');
        this.status = this.querySelector('[data-panel-status]');
        this.retry = this.querySelector('[data-panel-retry]');
        this.retryHandler = () => {
          if (this.variantId) { this.load(this.variantId); return; }
          const request = this.pendingSelection;
          const main = this.pendingMain;
          if (!main?.isConnected || !request?.selectedOptionValues?.length) return;
          const url = new URL(this.baseUrl);
          url.searchParams.delete('variant');
          url.searchParams.delete('section_id');
          url.searchParams.delete('sections');
          url.searchParams.set('view', 'ceiling-fan');
          if (window.Shopify?.theme?.role === 'unpublished') {
            url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
          }
          url.searchParams.set('option_values', request.selectedOptionValues.join(','));
          location.assign(url.toString());
        };
        this.retry?.addEventListener('click', this.retryHandler);
        this.bind = () => {
          if (!this.isConnected || this.unsubscribers || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribers = [
            subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
              const main = data?.event?.target?.closest('product-info');
              if (!main?.id?.startsWith('MainProduct-') || main.dataset.productId !== this.dataset.productId || main.dataset.originalSection) return;
              this.pendingMain = main;
              this.pendingSelection = { selectedOptionValues: [...data.selectedOptionValues], targetId: data.target.id };
              this.variantId = null;
              this.invalidate();
            }),
            subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              const main = document.getElementById(`MainProduct-${data?.sectionId}`);
              if (!main || main.dataset.productId !== this.dataset.productId || main.dataset.originalSection) return;
              this.load(data?.variant?.id, this.dataset.sectionId === data?.sectionId ? data.html : null);
            })
          ];
        };
        this.bind();
        document.addEventListener('DOMContentLoaded', this.bind, { once: true });
      }
      invalidate() {
        clearTimeout(this.timeout);
        this.sequence += 1;
        this.controller?.abort();
        this.contentNode.hidden = true;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loading;
        this.status.hidden = false;
        if (this.retry) this.retry.hidden = true;
        const sequence = this.sequence;
        this.timeout = setTimeout(() => {
          if (!this.isConnected || sequence !== this.sequence) return;
          this.sequence += 1;
          this.controller?.abort();
          this.fail();
        }, 12000);
      }
      async load(variantId, renderedHTML = null) {
        this.invalidate();
        this.variantId = variantId;
        const sequence = this.sequence;
        if (!variantId) { this.fail(); return; }
        this.controller = new AbortController();
        const url = new URL(this.baseUrl);
        url.searchParams.set('variant', String(variantId));
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.delete('sections');
        try {
          let html = renderedHTML;
          if (!html) {
            const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Section request failed');
            html = new DOMParser().parseFromString(await response.text(), 'text/html');
          }
          if (sequence !== this.sequence || !this.isConnected) return;
          const source = [...html.querySelectorAll('tls-fan-variant-panel')].find((panel) => panel.dataset.panelKey === this.dataset.panelKey && panel.dataset.productId === this.dataset.productId);
          if (!source || source.dataset.variantId !== String(variantId)) throw new Error('Variant panel mismatch');
          const content = source.querySelector('[data-panel-content]');
          if (!content) throw new Error('Variant panel missing content');
          const openIds = [...this.contentNode.querySelectorAll('details[open][id]')].map((item) => item.id);
          this.contentNode.innerHTML = content.innerHTML;
          for (const detail of this.contentNode.querySelectorAll('details[id]')) if (openIds.includes(detail.id)) detail.open = true;
          this.dataset.variantId = String(variantId);
          this.contentNode.hidden = false;
          this.status.hidden = true;
          clearTimeout(this.timeout);
          this.removeAttribute('aria-busy');
        } catch (error) {
          if (sequence === this.sequence && this.isConnected && error.name !== 'AbortError') this.fail();
        }
      }
      fail() {
        clearTimeout(this.timeout);
        this.removeAttribute('aria-busy');
        this.status.textContent = this.dataset.error;
        this.status.hidden = false;
        if (this.retry) this.retry.hidden = !this.variantId && !this.pendingSelection;
      }
      disconnectedCallback() {
        clearTimeout(this.timeout);
        this.sequence += 1;
        this.controller?.abort();
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
        this.unsubscribers = null;
        this.retry?.removeEventListener('click', this.retryHandler);
        document.removeEventListener('DOMContentLoaded', this.bind);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tls-pdp-contact-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tls-pdp-contact-link')) {
  customElements.define('tls-pdp-contact-link', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const link = this.querySelector('[data-enquiry-link]');
      const variants = JSON.parse(this.querySelector('[data-enquiry-variants]').textContent);
      const update = (variantId) => {
        const main = Array.from(document.querySelectorAll('product-info')).find(item => item.id.startsWith('MainProduct-') && item.dataset.productId === this.dataset.productId);
        const selected = main?.querySelector('form[action*="/cart/add"] [name="id"]');
        const candidate = typeof variantId === 'string' || typeof variantId === 'number' ? String(variantId) : selected?.value;
        const id = selected && !selected.disabled && variants[candidate] ? candidate : '';
        const destination = new URL(link.getAttribute('href'), location.origin);
        const productUrl = new URL(this.dataset.productUrl, location.origin);
        if (id) productUrl.searchParams.set('variant', id);
        destination.searchParams.set('pdp_product', this.dataset.productTitle);
        destination.searchParams.set('pdp_url', productUrl.href);
        const option = id ? variants[id] : '';
        destination.searchParams.set('pdp_option', this.dataset.omitDefaultOption === 'true' && option === 'Default Title' ? '' : option);
        destination.hash = 'ContactForm';
        link.href = destination.href;
      };
      this.updateEnquiry = update;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const main = Array.from(document.querySelectorAll('product-info')).find(item => item.id.startsWith('MainProduct-') && item.dataset.productId === this.dataset.productId);
          if (main && String(data.sectionId) === String(main.dataset.section)) update(data.variant?.id || '');
        });
      }
      update();
      link.addEventListener('click', update);
      link.addEventListener('pointerdown', update);
      link.addEventListener('focus', update);
    }
    disconnectedCallback() {
      this.unsubscribeVariant?.();
      const link = this.querySelector('[data-enquiry-link]');
      if (link && this.updateEnquiry) {
        ['click', 'pointerdown', 'focus'].forEach(type => link.removeEventListener(type, this.updateEnquiry));
      }
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tls-pdp-decision"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tls-pdp-decision')) {
    customElements.define('tls-pdp-decision', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        this.abort = new AbortController();
        this.variants = JSON.parse(this.querySelector('[data-comparison-variants]')?.textContent || '[]');
        this.productInfo.addEventListener('click', (event) => {
          if (!event.target.closest('[data-decision-measure]')) return;
          const heading = this.querySelector('h2[id]');
          if (!heading) return;
          event.preventDefault();
          heading.focus({ preventScroll: true });
          heading.scrollIntoView({ block: 'start', behavior: 'auto' });
        }, { signal: this.abort.signal });
        this.addEventListener('click', (event) => {
          const back = event.target.closest('[data-back]');
          const link = event.target.closest('[data-select]');
          const selects = this.productInfo.querySelectorAll('variant-selects select');
          if (back && selects[0]) {
            event.preventDefault();
            selects[0].focus();
            selects[0].scrollIntoView({ block: 'center', behavior: 'auto' });
          }
          if (!link || !selects[0] || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const card = link.closest('[data-count]');
          const option = Array.from(selects[0].options).find(item => item.value === card.dataset.count);
          if (!option || link.hidden || option.disabled) { event.preventDefault(); return; }
          event.preventDefault();
          if (selects[0].value === option.value) { selects[0].focus(); return; }
          selects[0].value = option.value;
          selects[0].dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal: this.abort.signal });
        this.productInfo.addEventListener('change', (event) => {
          if (event.target.closest('variant-selects')) {
            this.pendingQuantity = this.productInfo.querySelector('quantity-input input')?.value;
            this.refresh();
          }
        }, { signal: this.abort.signal });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.section) return;
            const quantity = this.productInfo.querySelector('quantity-input input');
            if (quantity && this.pendingQuantity != null) {
              const fallback = quantity.value;
              quantity.value = this.pendingQuantity;
              if (!quantity.checkValidity()) quantity.value = fallback;
              quantity.dispatchEvent(new Event('change', { bubbles: true }));
            }
            this.pendingQuantity = null;
            this.refresh();
          });
        }
        const picker = this.productInfo.querySelector('variant-selects');
        this.observer = new MutationObserver(() => this.refresh());
        if (picker) this.observer.observe(picker, { childList: true, subtree: true });
        this.refresh();
      }
      refresh() {
        const selects = this.productInfo.querySelectorAll('variant-selects select');
        if (selects.length !== 2 || !this.variants.length) return;
        this.querySelectorAll('[data-count]').forEach(card => {
          const variant = this.variants.find(v => v.count === card.dataset.count && v.light === selects[1].value);
          const link = card.querySelector('[data-select]');
          const available = Boolean(variant?.available);
          link.hidden = !available;
          card.querySelector('[data-price]').textContent = available ? variant.price : this.querySelector('[data-unavailable]').textContent;
          card.setAttribute('aria-current', String(available && card.dataset.count === selects[0].value));
          if (variant) {
            const url = new URL(this.productInfo.dataset.url, location.origin);
            url.searchParams.set('variant', String(variant.id));
            link.href = url.pathname + url.search;
          }
        });
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.unsubscribeVariant?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tls-pdp-island-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tls-island-layout')) {
    customElements.define('tls-island-layout', class extends HTMLElement {
      connectedCallback() {
        if (!this.ready) {
          this.ready = true;
          this.form = this.querySelector('form');
          this.field = name => this.form.elements.namedItem(name);
          this.svg = this.querySelector('[data-drawing]');
          this.shapes = this.querySelector('[data-shapes]');
          this.result = this.querySelector('[data-result]');
          this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
          this.messages.illustration = this.querySelector('.tls-island__view-label').textContent;
          this.messages.measure_first = '';
          this.example = this.querySelector('[data-example]');
          this.unitControl = document.getElementById(this.dataset.unitControl);
          this.unit = this.unitControl?.value || 'in';
          this.example.textContent = this.unit === 'cm' ? this.messages.example_cm : this.messages.example_in;
          this.form.querySelectorAll('button').forEach(button => button.disabled = false);
          this.notice = this.querySelector('[data-action-notice]');
          this.planner = this.closest('.shopify-section')?.querySelector('tls-pdp-space-planner');
          this.enhanced = !!this.planner?.classList.contains('fit-enhanced');
          this.knownDiameter = null;
          this.dimensionsChanged = event => {
            if (event.detail.productId !== this.dataset.productId) return;
            this.enhanced = true;
            this.knownDiameter = event.detail.width;
            if (this.knownDiameter !== null && event.detail.unit !== this.unit) this.knownDiameter *= this.unit === 'cm' ? 2.54 : 1/2.54;
            if (this.knownDiameter !== null) this.knownDiameter = Number(this.knownDiameter.toFixed(3));
            this.field('diameter').value = this.knownDiameter ?? '';
            if (this.active && this.knownDiameter !== null) this.form.dispatchEvent(new Event('submit', { bubbles:true, cancelable:true }));
          };
          document.addEventListener('tls:fit-dimensions',this.dimensionsChanged);
          this.querySelector('[data-load-example]').addEventListener('click', () => {
            const factor = this.unit === 'cm' ? 1 : 1 / 2.54;
            for (const [name, value] of Object.entries({length:240, diameter:30, margin:30})) this.field(name).value = String(Number((value * factor).toFixed(3)));
            if (this.enhanced && this.knownDiameter !== null) this.field('diameter').value = this.knownDiameter;
            this.clear();
            this.notice.textContent = this.enhanced && this.knownDiameter !== null ? this.planner.copy.island_example : this.messages.example_loaded;
            if (this.enhanced) this.form.dispatchEvent(new Event('submit', { bubbles:true, cancelable:true }));
          });
          this.querySelector('[data-clear]').addEventListener('click', () => {
            for (const name of ['length','diameter','margin']) this.field(name).value = '';
            this.active = false;
            if (this.enhanced && this.knownDiameter !== null) this.field('diameter').value = this.knownDiameter;
            this.clear(); this.notice.textContent = '';
          });
          this.clear = () => { this.values = null; this.result.replaceChildren(); this.drawGuide(); };
          this.form.addEventListener('input', event => {
            if (event.target !== this.field('count')) { const hadResult = !!this.values; this.clear(); if (this.enhanced && this.active) this.form.dispatchEvent(new Event('submit', { bubbles:true, cancelable:true })); else if (hadResult) this.result.textContent = this.messages.stale; }
          });
          this.unitChanged = () => {
            const next = this.unitControl.value;
            if (next !== this.unit && this.knownDiameter !== null) this.knownDiameter = Number((this.knownDiameter * (next === 'in' ? 1/2.54 : 2.54)).toFixed(3));
            if (next !== this.unit) for (const name of ['length','diameter','margin']) {
              const input = this.field(name);
              if (Number.isFinite(input.valueAsNumber)) input.value = String(Number((input.valueAsNumber * (next === 'in' ? 1/2.54 : 2.54)).toFixed(3)));
            }
            const calculated = !!this.values;
            this.unit = next; this.example.textContent = next === 'cm' ? this.messages.example_cm : this.messages.example_in; this.clear();
            if (calculated) this.form.dispatchEvent(new Event('submit', { bubbles:true, cancelable:true }));
          };
          this.unitControl?.addEventListener('change', this.unitChanged);
          this.field('count').addEventListener('change', () => {
            if (this.values) { this.values.n = Number(this.field('count').value); this.draw(); }
            else this.drawGuide();
          });
          this.form.addEventListener('submit', event => {
            event.preventDefault(); this.active = true; this.clear();
            const l=this.field('length').valueAsNumber,d=this.field('diameter').valueAsNumber,a=this.field('margin').valueAsNumber,n=Number(this.field('count').value);
            if (![l,d,a].every(Number.isFinite) || l<=0 || d<=0 || a<0 || ![2,3].includes(n)) { this.result.textContent=this.messages.invalid;return; }
            this.values={l,d,a,n}; this.draw();
          });
          this.selectionChanged = event => {
            const main=event.target.closest('variant-selects')?.closest('product-info');
            if (!main?.id?.startsWith('MainProduct-') || main.dataset.productId!==this.dataset.productId) return;
            this.field('diameter').value='';this.notice.textContent='';this.clear();this.result.textContent=this.messages.cleared;
          };
          this.drawGuide();
          if (this.enhanced) this.dimensionsChanged({detail:{productId:this.dataset.productId,width:this.planner.measure(this.planner.dimensions[this.planner.variant]?.width),unit:this.planner.unit}});
        }
        this.planner = this.closest('.tls-pdp__inner')?.querySelector('tls-pdp-space-planner');
        this.unitControl = document.getElementById(this.dataset.unitControl);
        this.enhanced = !!this.planner?.classList.contains('fit-enhanced');
        this.unitControl?.addEventListener('change', this.unitChanged);
        if (this.unitControl && this.unitControl.value !== this.unit) this.unitChanged();
        document.addEventListener('tls:fit-dimensions',this.dimensionsChanged);
        if (this.enhanced) this.dimensionsChanged({detail:{productId:this.dataset.productId,width:this.planner.measure(this.planner.dimensions[this.planner.variant]?.width),unit:this.planner.unit}});
        document.addEventListener('change',this.selectionChanged,true);
        this.observer=new ResizeObserver(() => { if(this.values)this.draw(); else this.drawGuide(); });
        this.observer.observe(this);
      }
      drawGuide() {
        const w=this.svg.clientWidth;if(w<1)return;
        this.svg.removeAttribute('hidden');this.svg.setAttribute('viewBox',`0 0 ${w} 170`);this.svg.style.height='170px';this.shapes.replaceChildren();
        const add=(tag,attrs,text)=>{const el=document.createElementNS('http://www.w3.org/2000/svg',tag);for(const [k,v]of Object.entries(attrs))el.setAttribute(k,v);if(text!==undefined)el.textContent=text;this.shapes.appendChild(el);};
        const label=(y,text)=>add('text',{x:w/2,y,'text-anchor':'middle'},text);
        add('rect',{x:20,y:44,width:w-40,height:74,rx:8,fill:'currentColor','fill-opacity':'.06',stroke:'currentColor','stroke-opacity':'.3'});
        const n=Number(this.field('count').value)||2,gap=(w-80)/(n+1),cy=81;
        for(let i=0;i<n;i++)add('circle',{cx:20+gap*(i+1),cy,r:18,fill:'currentColor','fill-opacity':'.65'});
        label(25,this.messages.illustration);label(151,this.messages.measure_first);
      }
      draw() {
        const {l,d,a,n}=this.values,m=this.messages,w=this.svg.clientWidth;
        if(w<1)return;
        const format=x=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:2}).format(x)+' '+this.unit;
        const gap=count=>{ const raw=(l-2*a-count*d)/(count-1);return Math.abs(raw)<1e-8*Math.max(l,d,a,1)?0:raw; };
        this.result.replaceChildren();
        for(const count of [2,3]) { const g=gap(count),p=document.createElement('p');p.textContent=(count===2?m.two:m.three)+': '+(g<0?m.negative:g===0?m.zero:m.gap+' '+format(g));this.result.appendChild(p); }
        const g=gap(n),scale=(w-40)/l,diameter=g>=0?d*scale:34,band=Math.max(70,diameter+24),bottom=70+band,height=bottom+100;
        this.svg.setAttribute('viewBox',`0 0 ${w} ${height}`);this.svg.style.height=height+'px';this.shapes.replaceChildren();
        const add=(tag,attrs,text)=>{const el=document.createElementNS('http://www.w3.org/2000/svg',tag);for(const [k,v]of Object.entries(attrs))el.setAttribute(k,v);if(text!==undefined)el.textContent=text;this.shapes.appendChild(el);};
        const label=(y,text)=>add('text',{x:w/2,y,'text-anchor':'middle'},text);
        label(30,m.length+': '+format(l));
        add('rect',{x:20,y:70,width:w-40,height:band,rx:6,fill:'currentColor','fill-opacity':'.06',stroke:'currentColor','stroke-opacity':'.3'});
        if(g<0){label(110,m.negative);return;}
        for(let i=0;i<n;i++)add('circle',{cx:20+(a+d/2+i*(d+g))*scale,cy:70+band/2,r:diameter/2,fill:'currentColor','fill-opacity':'.65'});
        const x1=20+(a+d)*scale,x2=x1+g*scale,y=bottom+14;
        add('path',{d:`M${x1} ${y-4}v8 M${x1} ${y}H${x2} M${x2} ${y-4}v8`,stroke:'currentColor',fill:'none'});
        label(bottom+40,m.gap+': '+format(g));label(bottom+65,m.end+': '+format(a));label(bottom+90,m.diameter+': '+format(d));
      }
      disconnectedCallback(){document.removeEventListener('change',this.selectionChanged,true);document.removeEventListener('tls:fit-dimensions',this.dimensionsChanged);this.unitControl?.removeEventListener('change',this.unitChanged);this.observer?.disconnect();}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tls-pdp-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const reveal = (hash, focus) => {
      if (!hash || hash === '#') return;
      let target;
      try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
      if (!target || !target.closest('.tls-pdp')) return;
      let parent = target;
      while (parent) {
        if (parent.tagName === 'DETAILS') parent.open = true;
        parent = parent.parentElement;
      }
      if (focus) {
        const heading = target.matches('details') ? target.querySelector('summary') : target;
        if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
        target.scrollIntoView({ block: 'start' });
      }
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-tls-pdp-link], a[data-decision-measure]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      const target = document.getElementById(url.hash.slice(1));
      if (!target || !target.closest('.tls-pdp')) return;
      event.preventDefault();
      history.replaceState(history.state, '', url.hash);
      reveal(url.hash, true);
    });
    window.addEventListener('hashchange', () => reveal(location.hash, true));
    reveal(location.hash, false);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tls-pdp-variant-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tls-pdp-variant-panel')) {
    customElements.define('tls-pdp-variant-panel', class extends HTMLElement {
      connectedCallback() {
        // DOM reordering reconnects existing panels; keep their in-flight refresh.
        if (this.panelConnected) return;
        this.panelConnected = true;
        this.baseUrl = new URL(location.href);
        if (document.querySelector('tls-pdp-variant-panel[data-panel-key^="outdoor-"], tls-pdp-variant-panel[data-panel-key^="wall-"]') &&
            window.Shopify?.theme?.role === 'unpublished' && window.Shopify.theme.id) {
          this.baseUrl.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
        }
        this.sequence = 0;
        this.contentNode = this.querySelector('[data-panel-content]');
        this.status = this.querySelector('[data-panel-status]');
        this.retry = this.querySelector('[data-panel-retry]');
        this.retryHandler = () => this.load(this.variantId);
        this.retry?.addEventListener('click', this.retryHandler);
        this.bind = () => {
          if (!this.isConnected || this.unsubscribers || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribers = [
            subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
              const main = data?.event?.target?.closest('product-info');
              if (!main?.id?.startsWith('MainProduct-') || main.dataset.productId !== this.dataset.productId || main.dataset.originalSection) return;
              this.variantId = null;
              this.invalidate();
            }),
            subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              const main = document.getElementById(`MainProduct-${data?.sectionId}`);
              if (!main || main.dataset.productId !== this.dataset.productId || main.dataset.originalSection) return;
              this.load(data?.variant?.id, this.dataset.sectionId === data?.sectionId ? data.html : null);
            })
          ];
        };
        this.bind();
        document.addEventListener('DOMContentLoaded', this.bind, { once: true });
      }
      invalidate() {
        clearTimeout(this.timeout);
        this.sequence += 1;
        this.controller?.abort();
        this.contentNode.hidden = true;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loading;
        this.status.hidden = false;
        if (this.retry) this.retry.hidden = true;
        const sequence = this.sequence;
        this.timeout = setTimeout(() => {
          if (!this.isConnected || sequence !== this.sequence) return;
          this.sequence += 1;
          this.controller?.abort();
          this.fail();
        }, 12000);
      }
      async load(variantId, renderedHTML = null) {
        this.invalidate();
        this.variantId = variantId;
        const sequence = this.sequence;
        if (!variantId) { this.fail(); return; }
        this.controller = new AbortController();
        const url = new URL(this.baseUrl);
        url.searchParams.set('variant', String(variantId));
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.delete('sections');
        try {
          let html = renderedHTML;
          if (!html) {
            const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin', ...(this.baseUrl.searchParams.get('view') === 'outdoor-lighting' ? { cache: 'no-cache' } : {}) });
            if (!response.ok) throw new Error('Section request failed');
            html = new DOMParser().parseFromString(await response.text(), 'text/html');
          }
          if (sequence !== this.sequence || !this.isConnected) return;
          const source = [...html.querySelectorAll('tls-pdp-variant-panel')].find((panel) => panel.dataset.panelKey === this.dataset.panelKey && panel.dataset.productId === this.dataset.productId);
          if (!source || source.dataset.variantId !== String(variantId)) throw new Error('Variant panel mismatch');
          const content = source.querySelector('[data-panel-content]');
          if (!content) throw new Error('Variant panel missing content');
          const openIds = [...this.contentNode.querySelectorAll('details[open][id]')].map((item) => item.id);
          this.contentNode.innerHTML = content.innerHTML;
          for (const detail of this.contentNode.querySelectorAll('details[id]')) if (openIds.includes(detail.id)) detail.open = true;
          this.dataset.variantId = String(variantId);
          this.contentNode.hidden = false;
          this.status.hidden = true;
          clearTimeout(this.timeout);
          this.removeAttribute('aria-busy');
        } catch (error) {
          if (sequence === this.sequence && this.isConnected && error.name !== 'AbortError') this.fail();
        }
      }
      fail() {
        clearTimeout(this.timeout);
        this.removeAttribute('aria-busy');
        this.status.textContent = this.dataset.error;
        this.status.hidden = false;
        if (this.retry) this.retry.hidden = !this.variantId;
      }
      disconnectedCallback() {
        // Moving a details section disconnects and reconnects it in the same turn.
        // Only tear down a panel that remains detached after the move completes.
        queueMicrotask(() => {
          if (this.isConnected) return;
          this.panelConnected = false;
        clearTimeout(this.timeout);
        this.sequence += 1;
        this.controller?.abort();
        this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
        this.unsubscribers = null;
        this.retry?.removeEventListener('click', this.retryHandler);
        document.removeEventListener('DOMContentLoaded', this.bind);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
